module.exports = __webpack_public_path__ + "static/assets/84d3c64acbdf7b075f017c5bac3fbb7d.svg";